var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSuccessCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 .917C15.281.917.917 15.28.917 33 .917 50.719 15.28 65.083 33 65.083c17.719 0 32.083-14.364 32.083-32.083C65.083 15.281 50.72.917 33 .917zm13.907 26.658a2.917 2.917 0 10-4.48-3.733L29.885 38.889l-6.49-6.493a2.917 2.917 0 00-4.124 4.124l8.75 8.75a2.916 2.916 0 004.302-.195l14.584-17.5z",
    fill: "#4CAF50"
  })));
}

export default SvgIconSuccessCheck;